import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom'; // добавлен Navigate
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import AdminPanel from './pages/AdminPanel';
import AdminDataCheck from './pages/AdminDataCheck';
import LandingPage from './pages/LandingPage';
import './App.css';

const Navigation = () => {
  const { isAuthenticated, logout, isAdmin, user  } = useAuth();
  
  if (!isAuthenticated) return null;
  
  return (
    <nav>
      <Link to="/">Мониторинг</Link>
      {user?.email !== 'demo@eosmon.ru' && <Link to="/settings">Настройки</Link>}
      {isAdmin && (
        <>
          <Link to="/admin">Администрирование</Link>
          <Link to="/admin/data-check">Проверка данных</Link>
        </>
      )}
      <button onClick={logout} className="logout-btn" style={{ marginLeft: 'auto' }}>
        Выйти ({user?.email})
      </button>
    </nav>
  );
};

function AppContent() {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }
  
  return (
    <>
      <Navigation />
      <Routes>
        {/* Публичный маршрут для корня – лендинг, если не авторизован */}
        <Route
          path="/"
          element={!isAuthenticated ? <LandingPage /> : <Navigate to="/dashboard" />}
        />
        {/* Отдельный дашборд для авторизованных */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/settings" element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        } />
        <Route path="/admin" element={
          <PrivateRoute adminOnly>
            <AdminPanel />
          </PrivateRoute>
        } />
        <Route path="/admin/data-check" element={
          <PrivateRoute adminOnly>
            <AdminDataCheck />
          </PrivateRoute>
        } />
        <Route path="/login" element={<LandingPage />} />
        {/*<Route path="/login" element={<Login />} />*/}
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <AppContent />
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;